import vue from 'vue';

export default function buildSequencePlateStore(store){
    store.actions.returnPlateToInProgress = async (context, params) => await vue.prototype.$myHttp.post('/api/sequencePlates/returnPlateToInProgress', params);
    store.actions.buildPlateDeviceList = async (context, params) => await vue.prototype.$myHttp.post('/api/sequencePlates/buildPlateDeviceList', params);
    store.actions.restoreArchiveFiles = async (context, params) => await vue.prototype.$myHttp.post('/api/sequencePlates/restoreArchiveFiles', params);
    store.actions.getActivePlateId = async (context, params) => await vue.prototype.$myHttp.post('/api/sequencePlates/GetActivePlateId', params);
    store.actions.setActivePlateId = async (context, params) => await vue.prototype.$myHttp.post('/api/sequencePlates/SetActivePlateId', params);
    return store;
}